import { useState } from "react";
import BlurCutoutInput from "../../components/ObjectPropertyBox/components/BlurCutoutInput";
import BlurInput from "../../components/ObjectPropertyBox/components/BlurInput";
import PanoramicViewMenu, {
  CameraViewInstructions,
} from "../../components/ObjectPropertyBox/components/PanoramicViewMenu";
import { useObjectsState } from "../../contexts/ObjectsProvider";
import { SmartObjectAdvancedPanel } from "../../lib/SmartObject/components/Svg/AdvancedPanel";
import { DropSeparator, Section } from "../ObjectPropertiesPanel";
import { useTimeline } from "../../contexts/TimelineProvider/TimelineProvider";
import { OBJECT_TYPE_SHAPE } from "../../const";
import FreeFormPolyMenu from "../../components/ObjectPropertyBox/components/FreeFormPolyMenu";

import styles from "./Advanced.module.css";

export const AdvancedPanel = ({ readOnly }: { readOnly?: boolean }) => {
  const { selectedObjects } = useObjectsState();
  const [tl] = useTimeline();
  const currentTime = tl?.scrubbingCurrentTime;
  const [showPanoramicViewMenu, setShowPanoramicViewMenu] = useState<boolean>(true);
  const [showMaskingMenu, setShowMaskingMenu] = useState<boolean>(true);
  const selectedObject = selectedObjects[0];
  const isSmartObject = selectedObject?.type === "smartObject";
  const isPanoramic = selectedObject?.type === "panoramic";
  const isFreeFormPoly = selectedObject?.type === "freeFormPoly";
  const isShape = selectedObject?.type === OBJECT_TYPE_SHAPE;

  return (
    <div
      className={styles.padding}
      style={{
        overflowY: "auto",
        height: "100%",
      }}
    >
      {isSmartObject && (
        <>
          <SmartObjectAdvancedPanel objectId={selectedObject.objectId} />
        </>
      )}

      {isShape && (
        <>
          <DropSeparator title="Mask Settings" setShowMenu={setShowMaskingMenu} showMenu={showMaskingMenu} />
          <section className="property-box-panel">
            {showMaskingMenu && isShape && <BlurCutoutInput selectedObject={selectedObject} isModalShown />}
          </section>
        </>
      )}
      {isPanoramic && (
        <>
          <Section title={"Camera view"} wrap>
            <CameraViewInstructions />
          </Section>
          <DropSeparator
            title="Camera settings"
            setShowMenu={setShowPanoramicViewMenu}
            showMenu={showPanoramicViewMenu}
          />
          {showPanoramicViewMenu && <PanoramicViewMenu selectedObject={selectedObject} />}
        </>
      )}
      {isFreeFormPoly && <FreeFormPolyMenu />}
    </div>
  );
};
